import styled from 'styled-components';
import cardone from '../../assets/cardone.png';
import cardtwo from '../../assets/cardtwo.png';
import cardthree from '../../assets/cardthree.png';
import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchVisitorTypes, fetchMeetingVenues, insertAppointment, fetchGateDetails, fetchNationality, fetchBuildingsByGate } from '../../services/Api';

const Container = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align items to the start (left) */
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
  margin-bottom: 20px;
    color:#2B3497;
`;

const CardWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const Card = styled.div`
  width: 288px;
  height: 101px;
  background-color: ${(props) => props.bgColor || '#fff'};
  box-shadow: 0px 10px 10px #00000038;
  border: 3px solid #FFFFFF;
  border-radius: 10px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 320px) {
    width: 90%;
  }
        @media (max-width: 1920px ) and (min-width: 1720px ) {
    width: 30%;

  }
       @media (max-width: 1720px ) and (min-width: 1520px ) {
    width: 30%;

  }
       @media (max-width: 1520px ) and (min-width: 1320px ) {
    width: 30%;

  }
      @media (max-width: 1320px ) and (min-width: 1120px ) {
    width: 30%;

  }
      @media (max-width: 1120px ) and (min-width: 920px ) {
    width: 30%;

  }
`;

const CardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
`;

const CardImage = styled.img`
  width: 35px;
  height: 40px;
`;

const CardText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  font-family: 'Segoe UI', 'Semibold';
`;

const CardTitle = styled.h2`
  font-size: 18px;
  color: ${(props) => props.textColor || '#000'};
`;

const CardSubtitle = styled.p`
  font-size: 14px;
  color: ${(props) => props.textColor || '#000'};
  margin-top: -1px;
`;

const CardCount = styled.div`
  font-size: 24px;
  color: ${(props) => props.textColor || '#000'};
  font-family: 'Segoe UI', 'Semibold';
`;
const SubHeading = styled.h2`
  font-size: 20px;
  font-family: 'Segoe UI', 'Semibold';
  margin: 5px 0;
    color:#2B3497;
`;


const RadioGroup = styled.div`
  display: flex;
  margin: 20px 0;
`;

const RadioLabel = styled.label`
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  color: #000;
  margin-right: 20px;
  font-weight: 600;
`;

const RadioInput = styled.input`
  margin-right: 10px;
`;


const InputCard = styled.div`
  width: 374px;
  height: 182px;
   background: #fff;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  
  margin: 20px auto 0;
  position: relative;
`;
const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 80%;
  height: 40px;
  border-bottom: 2px solid #2B3497;
  font-size: 14px;
  color: #000;
    margin-bottom: 20px;


  span {
    font-weight: bold;
    margin-right: 5px;
  }
`;

const StyledInput = styled.input`
  background-color: transparent;
  flex: 1;
  height: 40px;
  font-size: 14px;
  border: none;
  outline: none;
  text-align: left;
  &::placeholder {
    color: #000;
  }
`;

const InputField = styled.input`
  background-color: transparent;
  width: 80%;
  height: 20px;
  padding: 10px;
  font-size: 14px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 2px solid #2B3497;
  border-radius: 0;
  text-align: left;
  outline: none;

  &::placeholder {
    color: #000000;
  }

  /* Remove up and down arrows for number input */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::-moz-appearance {
    textfield;
  }
`;

const Button = styled.button`
  background-color: #2B3497;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 7px;
  box-shadow: 0px 10px 20px #2B349747;
  opacity: 1;
  cursor: pointer;
  width: 150px;
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: linear-gradient(#FFFFFF, #F5F5F5, #FFFFFF);
  box-shadow: 0px 0px 45px #0000004A;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 400px;
  height: 125px;
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
`;
const ISDInput = styled.input`
  width: 50px;
  background-color: transparent;
  height: 40px;
  font-size: 14px;
  border: none;
  outline: none;
  text-align: center;
  color: #000;
`;

const Checkout = () => {
  const [selectedOption, setSelectedOption] = useState('mobile');
  const [mobileNumber, setMobileNumber] = useState('');
  const [qrumber, setQrNumber] = useState('');
  const [cardCounts, setCardCounts] = useState({
    mobileCheckOutCount: 0,
    qrcodeCheckOutCount: 0,
    totalCheckOutCount: 0,

  });
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupSuc, setShowPopupSuc] = useState(false);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };
  const ISDSelect = styled.select`
  width: 80px;
  background-color: transparent;
  height: 40px;
  font-size: 14px;
  border: none;
  outline: none;
  text-align: center;
  color: #000;
  cursor: pointer;
`;

  const [nationalityList, setNationalityList] = useState('');
  const [defaultNationalityCode, setDefaultNationalityCode] = useState('');
  const handleIsdChange = (e) => {
    setMobileNumber('')

    const selectedNationality = nationalityList.find(
      (nation) => nation.nationalityCode === e.target.value
    );

    if (selectedNationality) {
      console.log("Selected Nationality Code:", selectedNationality.nationalityCode);
      setDefaultNationalityCode(selectedNationality.nationalityCode);
    }
  };

  useEffect(() => {
    // Fetch the card counts from the API
    const fetchCardCounts = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        const response = await axios.get(`${API_BASE_URL}/Dashboard/${0}`);
        setCardCounts({
          mobileCheckOutCount: response.data.checkout,
          qrcodeCheckOutCount: response.data.wqChkout,
          totalCheckOutCount: response.data.totalCheckOut,
        });
      } catch (error) {
        console.error('Error fetching card counts:', error);
      }
    };
    const getNationality = async () => {
      try {
        const nation = await fetchNationality();
        setNationalityList(nation);
        const defaultNation = nation.find(item => item.isDefault);
        if (defaultNation) {
          setDefaultNationalityCode(defaultNation.nationalityCode);
        }
      } catch (error) {
        console.error('Error fetching meeting venues:', error);
      }
    };

    getNationality();

    fetchCardCounts();
  }, []);
  const handleInputChange = (e) => {
    // Only allow numeric input
    if (/^\d*$/.test(e.target.value)) {
      setMobileNumber(e.target.value);
    }
    // setMobileNumber(e.target.value);
  };
  const handleInputQrChange = (e) => {
    const input = e.target.value.replace(/\s+/g, ''); // Removes all spaces from the input
    setQrNumber(input);
  };
















  const handleNextButtonClick = async () => {
    if (mobileNumber.trim() === "") {
      toast.error("Please enter the mobile number");
      return;
    }
    if (!defaultNationalityCode) {
      toast.error("Please select the nationality");
      return;
    }
    const formattedMobileNumber = `${defaultNationalityCode}-${mobileNumber}`;
    try {

      const responseAppointment = await axios.get(`/Appointment/Appointments/${formattedMobileNumber}`)
      if (responseAppointment.data == "You are not allowed to check-in this visitortype, Please contact administrator.") {
        toast.error("You are not allowed to check-in this visitortype, Please contact administrator.")
        return
      }
      console.log('Checkout Appointment API:', responseAppointment.data);
      if (responseAppointment.data.message == "Nationality code does not match") {
        toast.error("Nationality code does not match")
        return
      }
      if (responseAppointment.data.appointmentstatus === "Scheduled") {
        toast.error("Check in is not  done for the visitors")
        return;
      }
      if (responseAppointment.data.appointmentstatus === "Checked-Out") {
        setShowPopup(true);
        return;
      }
      else if (responseAppointment.data.appointmentstatus === "Checked-In") {
        const responseVisitorDeatils = await axios.get(`/VisitorDetails/GetVisitorDetailsPrePopluate?VisitorMob=${formattedMobileNumber}`);
        const AppId = responseVisitorDeatils.data.appointmentId
        console.log("AppId", AppId);
        const Stat = "OUT"
        console.log("Stat", Stat);
        const updateAppoinmentStatus = await axios.post(`/Appointment/AppointStatusUpd/${AppId},${Stat}`);
        const responseVisitorDeatilsV = await axios.put(`/VisitorDetails/VisitorDetails/${formattedMobileNumber}`);
        setMobileNumber('');
        setShowPopupSuc(true)
        const fetchCardCounts = async () => {
          try {
            const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

            const response = await axios.get(`${API_BASE_URL}/Dashboard/${0}`);
            setCardCounts({
              mobileCheckOutCount: response.data.checkout,
              qrcodeCheckOutCount: response.data.wqChkout,
              totalCheckOutCount: response.data.totalCheckOut
            });
          } catch (error) {
            console.error('Error fetching card counts:', error);
          }
        };

        fetchCardCounts();
      }
      if (responseAppointment.data.message === "Appointment is not scheduled for this mobile number") {
        const responseVisitorDeatils = await axios.get(`/VisitorDetails/GetVisitorDetailsPrePopluate?VisitorMob=${formattedMobileNumber}`);
        if (responseVisitorDeatils.data.messageToVisitor == "Nationality code does not match") {
          toast.error("Nationality code does not match")
          return
        }

        console.log("responseVisitorDeatils", responseVisitorDeatils.data);
        if (responseVisitorDeatils.data.messageToVisitor == "Visitor details not found") {
          toast.error("Visitor details not found")
          return
        }
        else if (responseVisitorDeatils.data.messageToVisitor == "Allow visitor to Walkin Checkin") {
          setShowPopup(true);
          return;

        } else if (responseVisitorDeatils.data.messageToVisitor == "Visitor Already Checked In") {
          const responseVisitorDeatilsV = await axios.put(`/VisitorDetails/VisitorDetails/${formattedMobileNumber}`);
          setMobileNumber('');
          setShowPopupSuc(true);
          const fetchCardCounts = async () => {
            try {
              const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

              const response = await axios.get(`${API_BASE_URL}/Dashboard/${0}`);
              setCardCounts({
                mobileCheckOutCount: response.data.checkout,
                qrcodeCheckOutCount: response.data.wqChkout,
                totalCheckOutCount: response.data.totalCheckOut
              });
            } catch (error) {
              console.error('Error fetching card counts:', error);
            }
          };

          fetchCardCounts();
        }
        return;
      }


    } catch (error) {
      console.error('Error fetching appointment details:', error);
      // Handle error scenarios
    }
  };
  function decodeCheckInId(qrcode) {
    // Mapping encoded byte pairs back to digits
    const reverseMapping = {
      "515253": "1",
      "303030": "3",
      "505050": "5",
      "202020": "2",
      "868484": "4",
      "606060": "6",
      "707070": "7",
      "808080": "8",
      "909090": "9",
      "000000": "0"
    };

    let checkInId = '';

    // Loop through the qrcode string in steps of 6 characters (each code is 6 characters long)
    for (let i = 0; i < qrcode.length; i += 6) {
      const segment = qrcode.substring(i, i + 6); // Extract each 6-character segment
      // Check if the segment exists in the reverse mapping
      if (reverseMapping[segment]) {
        checkInId += reverseMapping[segment]; // Map the segment back to the corresponding digit
      } else {
        console.error(`Error: Segment ${segment} not found in reverse mapping`);
        return ''; // Return an empty string if an invalid segment is encountered
      }
    }

    return checkInId; // Return the decoded check-in ID
  }

  const handleNextButtonQRClick = async () => {
    if (qrumber == '') {
      toast.error("Please enter the QR code")
      return
    }
    // const decryptedNumber = decryptQRCode(qrumber);
    // console.log("decryptedNumber",decryptedNumber);
    console.log("QrCode", qrumber);
    const decodedId = decodeCheckInId(qrumber);
    console.log("Decoded:", decodedId);
    try {
      const responseAppointment = await axios.put(`/VisitorDetails/QRCodeCheckOut/${qrumber},${true}`);
      console.log(responseAppointment);
      toast.success(responseAppointment.data)
      if (responseAppointment.data == "Successfully checkedOut") {
        setQrNumber('');
        setShowPopupSuc(true)

      }
      setQrNumber('');

    } catch (error) {
      setQrNumber('');
    }

    // try {

    //   const responseAppointment = await axios.get(`/Appointment/Appointments/${decryptedNumber}`);
    //   if(responseAppointment.status == 204) {
    //     const responseVisitorDeatils = await axios.put(`/VisitorDetails/VisitorDetails/${decryptedNumber}`);
    //     if(responseVisitorDeatils.data =="Failed to update") {
    //       toast.error('No appointment is scheduled for the entered mobile number.')
    //       return
    //     }
    //     // if(responseVisitorDeatils.status == 200){
    //     //   setMobileNumber('');
    //     //   setShowPopupSuc(true)
    //     //   return;
    //     // }
    //   }
    //   console.log('Checkout Appointment API:', responseAppointment.data);
    //   const responseVisitorDeatils = await axios.get(`/VisitorDetails/VisitorDetails/${responseAppointment.data.visitorMobile}`);
    //   console.log('Checkout Visitors API:', responseVisitorDeatils.data);
    //   console.log('Checkout Visitors API:', responseVisitorDeatils.data.checkOutType);
    //   if (responseVisitorDeatils.data.passReturned === "Y") {
    //     setQrNumber('');
    //     setShowPopup(true);
    //     return;
    //   }

    //   if (responseVisitorDeatils.data.passReturned === "") {
    //     console.log("checkout type is null");
    //     const AppId = responseVisitorDeatils.data.appointmentId
    //     console.log("AppId", AppId);
    //     const Stat = "OUT"
    //     console.log("Stat", Stat);
    //     const responsev = await axios.get(`/Appointment/Appointments/${decryptedNumber}`);


    //     const updateAppoinmentStatus = await axios.post(`/Appointment/AppointStatusUpd/${AppId},${Stat}`);
    //     console.log('update AppoinmentStatus API:', updateAppoinmentStatus);
    //     const updateResponseVisitorDeatils = await axios.put(`/VisitorDetails/QRCheckOut/${responseAppointment.data.visitorMobile}`);
    //     console.log('updateResponseVisitorDeatils:', updateResponseVisitorDeatils.data);
    //     const empID = localStorage.getItem('employeeId');
    //     const getManagerDetails = await axios.get(`/Employee/${empID}`);
    //     console.log("getManagerDetails :",getManagerDetails.data);
    //     const updatedFormData = {
    //       VisitorName: responseVisitorDeatils.data.visitorName,
    //       MailSubject: 'Visitor CheckOut Notification',
    //       MailType: 'CHKOUTVISITOR',
    //       MeetingOn:  responseVisitorDeatils.data.meetingOn,
    //       VisitorMobile: responseVisitorDeatils.data.visitorMobile,
    //       MeetingVenue: responsev.data.meetingvenue,
    //       txtManagersID: "",
    //       ManagerMail: getManagerDetails.data.managerMailID,
    //       SecsEmailId: "",
    //       VisitorCompany: responseVisitorDeatils.data.visitorCompany,
    //       HostName: updateResponseVisitorDeatils.data.hostName,
    //       ToAddress:responsev.data.visitorEmail,
    //     }
    //     console.log("updatedFormData",updatedFormData);
    //     const updateMail = await axios.post('/Mail', updatedFormData);
    //     console.log("updateMail",updateMail);

    //     const sendSmsData = {
    //       AppointmentDtTm:responseAppointment.data.meetingOn,
    //       AppointmentVenue:responseAppointment.data.meetingvenue,
    //       ContactNo:"+91"+updateResponseVisitorDeatils.data.hostMobile ,
    //       HostName:updateResponseVisitorDeatils.data.hostName,
    //       SMSType:"MsgToHostCHKOUT",
    //       VisitorName:updateResponseVisitorDeatils.data.visitorName
    //     }
    //     console.log("sendSmsData",sendSmsData);
    //     const updateSendSms = await axios.post('/SendSMS', sendSmsData);
    //     console.log("updateSendSms",updateSendSms);
    //     setQrNumber('');

    //   }


    // } catch (error) {
    //   console.error('Error fetching appointment details:', error);
    //   // Handle error scenarios
    // }
    const fetchCardCounts = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        const response = await axios.get(`${API_BASE_URL}/Dashboard/${0}`);
        setCardCounts({
          mobileCheckOutCount: response.data.checkout,
          qrcodeCheckOutCount: response.data.wqChkout,
          totalCheckOutCount: response.data.totalCheckOut,
        });
      } catch (error) {
        console.error('Error fetching card counts:', error);
      }
    };

    fetchCardCounts();
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleClosePopupSuc = () => {
    setShowPopupSuc(false);
  };


  function decryptQRCode(qrCode) {
    let decryptedNumber = '';
    for (let i = 0; i < qrCode.length; i += 2) {
      const asciiValue = qrCode.substring(i, i + 2);
      decryptedNumber += String.fromCharCode(parseInt(asciiValue, 10));
    }

    // Use a regular expression to extract only the digits from the decrypted string
    const mobileNumber = decryptedNumber.match(/\d+/)[0];
    return mobileNumber;
  }


  return (
    <Container>
      <Heading>Visitor Check-Out Count</Heading>
      <CardWrapper>
        <Card bgColor="#A2BECB">
          <CardContent>
            <CardImage src={cardone} alt="Card Image" />
            <CardText>
              <CardTitle>Mobile Check-Out</CardTitle>
              <CardSubtitle>Today's Count</CardSubtitle>
            </CardText>
            <CardCount>{cardCounts.mobileCheckOutCount}</CardCount>
          </CardContent>
        </Card>
        <Card bgColor="#A2BECB">
          <CardContent>
            <CardImage src={cardtwo} alt="Card Image" />
            <CardText>
              <CardTitle>QR Code Check-Out</CardTitle>
              <CardSubtitle>Today's Count</CardSubtitle>
            </CardText>
            <CardCount>{cardCounts.qrcodeCheckOutCount}</CardCount>
          </CardContent>
        </Card>
        <Card bgColor="#7C7C7C">
          <CardContent>
            <CardImage src={cardthree} alt="Card Image" />
            <CardText>
              <CardTitle textColor="#fff">Total Check-Out</CardTitle>
              <CardSubtitle textColor="#fff">Today's Count</CardSubtitle>
            </CardText>
            <CardCount textColor="#fff">{cardCounts.totalCheckOutCount}</CardCount>
          </CardContent>
        </Card>
      </CardWrapper>
      <SubHeading>Check-Out</SubHeading>
      <RadioGroup>
        <RadioLabel>
          <RadioInput
            type="radio"
            value="mobile"
            checked={selectedOption === 'mobile'}
            onChange={handleOptionChange}
          />
          Using Mobile Number
        </RadioLabel>
        <RadioLabel>
          <RadioInput
            type="radio"
            value="qr"
            checked={selectedOption === 'qr'}
            onChange={handleOptionChange}
          />
          Using QR Code
        </RadioLabel>
      </RadioGroup>
      <InputCard>
        {selectedOption === 'mobile' && (
          <>
            <InputWrapper>
              {/* <span>ISD+{defaultNationalityCode}</span> */}
              <ISDSelect onChange={handleIsdChange} value={defaultNationalityCode}
                title={
                  Array.isArray(nationalityList) && nationalityList.length > 0
                    ? (() => {
                      const selectedNation = nationalityList.find(
                        (nation) => nation.nationalityCode === defaultNationalityCode
                      );
                      return selectedNation
                        ? `${selectedNation.name} (${selectedNation.nationalityCode})`
                        : 'Select Nationality';
                    })()
                    : 'Loading...'
                }>
                {Array.isArray(nationalityList) && nationalityList.length > 0 ? (
                  <>
                    <option value="" disabled selected>
                      Select Nationality
                    </option>
                    {nationalityList.map((nation) => (
                      <option
                        key={nation.id}
                        value={nation.nationalityCode}
                        disabled={nation.isBlackListed}
                      >
                        {nation.name} ({nation.nationalityCode})
                      </option>
                    ))}
                  </>
                ) : (
                  <option value="" disabled>Loading...</option>
                )}
              </ISDSelect>
              <StyledInput
                type="text"
                maxLength={defaultNationalityCode === "91" ? 10 : 15}
                value={mobileNumber}
                onChange={handleInputChange}
                placeholder="Enter Mobile Number"
              />
            </InputWrapper>
            <Button onClick={handleNextButtonClick}>Next</Button>
          </>
        )}
        {selectedOption === 'qr' && (
          <>
            <InputField
              type="text"
              placeholder="Scan QR Code"
              value={qrumber}
              onChange={handleInputQrChange}
            />
            <Button onClick={handleNextButtonQRClick}>Next</Button>
          </>
        )}
      </InputCard>
      {showPopup && (
        <Popup>
          <PopupText>Checkout already done for this Visitor</PopupText>
          <PopupButton onClick={handleClosePopup}>OK</PopupButton>
        </Popup>
      )}
      {showPopupSuc && (
        <Popup>
          <PopupText> Visitor Left</PopupText>
          <PopupButton onClick={handleClosePopupSuc}>OK</PopupButton>
        </Popup>
      )}
      <ToastContainer />
    </Container>
  );
};

export default Checkout;
